const footer = document.getElementsByClassName("footer")[0];
const container = footer.getElementsByClassName("legal")[0];
const footerEllipsis = footer.getElementsByClassName("footer-ellipsis")[0] as HTMLDivElement;
const footerOverlay = footer.getElementsByClassName("footer-overlay")[0] as HTMLDivElement;
const links = container?.getElementsByTagName("a");
const arr = Array.from(links ?? []);
const elementWidths = arr.map((value, index) => {
  if (index > 0 && index < 3) {
    value.style.overflow = "hidden";
    value.style.textOverflow = "ellipsis";
  }

  return value.scrollWidth;
});

const observer = new ResizeObserver(() => {
  handleOverflow(container.clientWidth, arr);
});

observer.observe(footer);

footerEllipsis.addEventListener("click", () => {
  if (footerOverlay.style.display === "block") {
    footerOverlay.style.display = "none";
  } else {
    footerOverlay.style.display = "block";
  }
});

function handleOverflow(containerWidth: number, elements: HTMLAnchorElement[]) {
  let items = sortFooterItems(containerWidth, elements);

  footerEllipsis.style.display = items.hiddenElements.length > 0 ? "flex" : "none";

  if (items.hiddenElements.length > 0) {
    items = sortFooterItems(containerWidth - 49, arr);
  }

  const childNodes = Array.from(footerOverlay.children ?? []) as HTMLAnchorElement[];
  const removedClones = getHrefDiff(childNodes, items.hiddenElements);
  const addedElements = getHrefDiff(items.hiddenElements, childNodes).reverse();


  addedElements.forEach((value) => {
    value.style.display = "none";
    const clone = value.cloneNode(true) as HTMLAnchorElement;
    clone.style.display = "flex";
    let firstElement = footerOverlay.children[0];

    if (firstElement) {
      footerOverlay.insertBefore(clone, firstElement);
    } else {
      footerOverlay.appendChild(clone);
    }
  });

  removedClones.forEach((clone) => {
    const element = items.visibleElements.find((x) => x.href == clone.href);

    if (element) {
      element.style.display = "flex";
    }
    footerOverlay.removeChild(clone);
  });
}

function sortFooterItems(totalWidth: number, elements: HTMLAnchorElement[]) {
  const visibleElements: HTMLAnchorElement[] = [];
  const hiddenElements: HTMLAnchorElement[] = [];

  let accumulatedWidth = 0;
  elements.forEach((current, currentIndex) => {
    accumulatedWidth += elementWidths[currentIndex] + 24;
    if (accumulatedWidth <= totalWidth || currentIndex < 3) {
      visibleElements.push(current);
    } else {
      hiddenElements.push(current);
    }
  });

  return { visibleElements, hiddenElements };
}

function getHrefDiff(arr1: HTMLAnchorElement[], arr2: HTMLAnchorElement[]) {
  return arr1.filter((x) => !arr2.some((y) => x.href === y.href));
}
